import { render, staticRenderFns } from "./r-reward-package-page.vue?vue&type=template&id=4f915dd4"
import script from "./r-reward-package-page.vue?vue&type=script&lang=js"
export * from "./r-reward-package-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f915dd4')) {
      api.createRecord('4f915dd4', component.options)
    } else {
      api.reload('4f915dd4', component.options)
    }
    module.hot.accept("./r-reward-package-page.vue?vue&type=template&id=4f915dd4", function () {
      api.rerender('4f915dd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/reward-pack/r-reward-package-page.vue"
export default component.exports